import CybsButton from '@cybs-ui/components/lib/button';
import React from 'react';
import { connect } from 'react-redux';
import { getHasBodyParams, getMethodType, getPath } from '../../../../../lhs/reducers/lhs-reducer';
import { getExampleKey } from '../../../reducers/examples-reducer';
import { getExampleDataUsingExampleId } from '../../combobox/js/sample-request-dropdown';
import { getHasQueryParams, getJsTree, getQueryParametersCounter, getQueryParamsDefaultValues, getSpecData, getUrlCounter } from '../../../../dynamic/reducers/rhs-schema-reducer';
import { updateQueryParams, updateSpecBasedExampleData } from '../../../actions/rhs-schema-actions';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
var queryParamsControl = "";

// Reset functionality 
function resetFunctionality(queryParamsControl) {

    if (getHasBodyParams()) {
        if (getExampleKey() != null || getExampleKey() != undefined) {
            if (getExampleDataUsingExampleId(getExampleKey())) {
                var exampleData = getExampleDataUsingExampleId(getExampleKey());
                var requiredFields = exampleData['requiredFields'];
                updateSpecBasedExampleData(exampleData['value'],requiredFields,false);
            }
        }
    }
    var expandedElements = document.getElementsByClassName("rct-icon-expand-open");
    for (var i = expandedElements.length - 1; i >= 0; i--) {

        if (expandedElements[i].parentElement) {
            expandedElements[i].parentElement.click();
        }
    }
    if (queryParamsControl && getHasQueryParams()) {
        updateQueryParams(getSpecData(), getPath(), getMethodType());
        var value = (getQueryParametersCounter() === undefined ? 0 : getQueryParametersCounter());
        var urlCounter = (getUrlCounter() === undefined ? 0 : getUrlCounter());
        if (value >= 0) {
            // putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES',queryParamsCurrentValues:{}});
            putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMS_CONTROL',queryParamsControl:'requestUrl'});
            if(queryParamsControl != undefined && queryParamsControl != null)
            {
                    putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMETERS_COUNTER', queryParametersCounter: ++value }); 
                    putDataInDevCenterDataStore({ type: 'UPDATE_URL_PARAMETERS_COUNTER', urlCounter: (++urlCounter)});
                    // putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES',queryParamsCurrentValues:getQueryParamsCurrentValues()});
                    putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES',queryParamsCurrentValues:{...getQueryParamsDefaultValues()}});
                     window.location.reload();
                    // $( "#live-console-tabs" ).load(window.location.href + " #here" );
                    // var elementMap = getQueryParamsDefaultValues();
                    // var index =0;
                    // if(elementMap != undefined)
                    // {
                    //     for(var element in elementMap)
                    //         {
                    //             var elementInQueryParam = document.getElementById('textfield'+index);
                    //             var elementInurl = document.getElementById(element);
                    //             if(elementInQueryParam != null)
                    //             {
                    //                 console.log(elementMap[element]);
                    //                 elementInQueryParam.setAttribute("value",elementMap[element]);
                    //                 console.log(elementInQueryParam);

                    //             }
                    //             if(elementInurl != null)
                    //             {
                    //                 console.log(elementMap[element]);
                    //                 elementInurl.setAttribute("value",elementMap[element]);
                    //                 console.log(elementInurl);

                    //             }
                    //             index++;
                    //         }

                    // }
                    

            }
            // putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMS_CONTROL', queryParamsControl: 'liveConsole' });
        }
    }
}

class ResetFunctionalityInLiveConsole extends React.Component {

    render() {
        // $( "#live-console-tabs" ).on('click',function(){console.log("live console tabs is clicked")});
        return (

            <CybsButton
                aria-label="Reset button for the body code content"
                aria-description="On click of this button the code in the code editor gets reset to default"
                className = "border_color_theme_primary"
                colorScheme="secondary"
                dataTest="left"
                i18n={{ ariaLabel: <b>information icon</b>, label: 'Reset' }}
                iconClass="reload"
                iconLocation="left"
                onClick={() => resetFunctionality(this.props.queryParamsControl)}
            />
        );

    }
}
function mapStateToProps(state) {
    queryParamsControl = (state.rhsReducer.queryParamsControl == undefined) ? null : state.rhsReducer.queryParamsControl
    return {
        queryParamsControl :queryParamsControl,
        queryParamsDefaultValues : (state.rhsReducer.queryParamsDefaultValues == undefined) ? null : state.rhsReducer.queryParamsDefaultValues
    };

}

export default connect(mapStateToProps)(ResetFunctionalityInLiveConsole);